import { Product } from "../product/ProductModel";

export class OrderItemModel {
  id: string;
  orderId: string;
  productId: string;
  companyCode: string;
  storeCode: string;
  quantity: number;
  comments: string;
  unitPrice: number;
  totalPrice: number;
  createdAt: Date;
  product: Product;

  constructor(data: Partial<any> = {}) {
    this.id = data.id;
    this.orderId = data.orderId;
    this.productId = data.productId;
    this.companyCode = data.companyCode;
    this.storeCode = data.storeCode;
    this.quantity = Number(data.quantity);
    this.comments = data.comments;
    this.unitPrice = Number(data.unitPrice);
    this.totalPrice = Number(data.totalPrice);
    this.createdAt = new Date(data.createdAt);
    this.product = data.product;
  }
}
